import { useMutation, useQueryClient } from 'react-query';
import axios from '../../../utils/axios';
import { apiurl } from '../../../config/apiUrl';
import removeEmpty from '../../../utils/removeEmptyValuesFromObject';

const filterExpenseQuery = (data) => {
  const cleanedData = removeEmpty(data);
  return axios.post(apiurl?.getexpenseitemlist, cleanedData);
};

const filterExpenseItems = () => {
  const queryClient = useQueryClient();
  return useMutation(filterExpenseQuery, {
    onSuccess: (resData) => {
      queryClient.setQueriesData(['getexpenseitemlist'], resData);
    }
  });
};

export default filterExpenseItems;
